"use strict";

import React from "react";
import PropTypes from "prop-types";
import ModalDialog from "../../controls/ModalDialog";

const UserCreatedSuccessfullyDialog = props => {

    const buttons = [{
        bsStyle: "primary",
        cssClass: "btn btn-primary",
        onClick: props.onOk,
        key: "userCreatedSuccessfully",
        text: "Ok"
    }];

    let user = props.user;

    if (!props.user) {
        user = {};
    }

    const content = <div className="newUserCreatedDialog">
        <p>
            <span>{user.firstName} {user.lastName} has been created for Site ID: {user.site}</span><br/>
            <span>User ID: {user.login}</span>
        </p>
        <p>
            <span>Password: </span>
            <span><b>{user.newPassword}</b></span>
        </p>
        <p>
            <span>
                    Please notify the new user of their new User ID and system generated password.
                    If you have access to Sentri7, Quantifi and/or Veriform, the password is for all applications.
            </span>
        </p>
    </div>;

    return (
        <ModalDialog id={props.id}
            title="New User Created"
            content={content}
            buttons={buttons}
            show={props.show}/>
    );

};

UserCreatedSuccessfullyDialog.propTypes = {
    id: PropTypes.string,
    show: PropTypes.bool.isRequired,
    onOk: PropTypes.func.isRequired,
    user: PropTypes.object
};

export default UserCreatedSuccessfullyDialog;
